import qs, { IStringifyOptions } from 'qs';

export const parse = <T> (query: string) => qs.parse(query) as T;
export const stringify = (obj: any, options?: IStringifyOptions) => qs.stringify(obj, options);

export const parseSearch = <T> (search: string) =>
  search && search.length > 1 ? parse<T>(search.substring(1)) : null;
